import { deleteCookie, getCookieValue, setCookieValue } from "utils";
import { UserToken } from "types";
import decode from "jwt-decode";

const AuthService = {
  DecodeJWT: (str: string): UserToken => {
    return decode<UserToken>(str);
  },

  GetUserID: (): number => {
    const { id } = AuthService.DecodeJWT(AuthService.GetToken() as string);
    return id;
  },

  GetSystemID: () => {
    const { systemID } = AuthService.DecodeJWT(
      AuthService.GetToken() as string,
    );
    return systemID;
  },

  GetUserTenantIDs: (): Array<number> => {
    const token = AuthService.GetToken();
    if (token) {
      const { tenants } = AuthService.DecodeJWT(token);
      return tenants;
    }
    return [];
  },

  IsSuperAdmin: (): boolean => {
    const token = AuthService.GetToken();
    if (token) {
      const { roles } = AuthService.DecodeJWT(token);
      if (roles) {
        return roles.some((r: number) => r === 1);
      }
    }
    return false;
  },

  IsAdmin: (): boolean => {
    const token = AuthService.GetToken();
    if (token) {
      const { roles } = AuthService.DecodeJWT(token);
      if (roles) {
        return roles.some((r: number) => r === 2);
      }
    }
    return false;
  },

  IsTheOne: (): boolean => {
    const token = AuthService.GetToken();
    if (token) {
      const { id } = AuthService.DecodeJWT(token);
      return id === 1;
    }
    return false;
  },

  IsPM: (): boolean => {
    const token = AuthService.GetToken();
    if (token) {
      const { roles } = AuthService.DecodeJWT(token);
      if (roles) {
        return roles.some((r: number) => r === 5);
      }
    }
    return false;
  },

  GetToken: (): string => {
    return getCookieValue("tkn");
  },

  SetToken: (tkn: string) => {
    // set token cookie
    setCookieValue("tkn", tkn);
  },

  IsTokenExpired: (token: string): boolean => {
    try {
      const { exp } = AuthService.DecodeJWT(token);
      return exp < Date.now() / 1000;
    } catch (err) {
      return true;
    }
  },

  IsLoggedIn: (): boolean => {
    return (
      !!AuthService.GetToken() &&
      !AuthService.IsTokenExpired(AuthService.GetToken() as string)
    );
  },

  LogOut: (): void => {
    deleteCookie("lastUrl");
    deleteCookie("tkn");
  },
};

export default AuthService;
